import { render, staticRenderFns } from "./C2cSale.vue?vue&type=template&id=b62e984c&scoped=true&"
import script from "./C2cSale.vue?vue&type=script&lang=js&"
export * from "./C2cSale.vue?vue&type=script&lang=js&"
import style0 from "./C2cSale.vue?vue&type=style&index=0&id=b62e984c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62e984c",
  null
  
)

export default component.exports